<template>
  <v-container fluid class="inicio-dashboard px-3 px-md-8 py-4">
    <v-alert
      v-if="userLogged.b_castigado"
      outlined
      type="warning"
      dense
      prominent
      class="mb-4"
    >
      {{ userLogged.msg_castigado }}
    </v-alert>

    <v-row v-if="loading" align-content="center" justify="center" class="my-8">
      <v-col cols="12">
        <cargando-app text="Cargando Datos..." />
      </v-col>
    </v-row>

    <template v-else>
      <v-row class="dashboard-row">
        <v-col cols="12" lg="4">
          <patrimony-card :total="inicioData.patrimonio.total" :productos="inicioData.productos" />
        </v-col>

        <v-col cols="12" lg="8">
          <personal-info-card :user="user" />
        </v-col>
      </v-row>

      <product-cards-grid :productos="inicioData.productos" />

      <template v-if="!userBits.b_socio">
        <v-row class="dashboard-row">
          <v-col cols="12" lg="8" class="non-member-stack">
            <quick-actions-card :acciones="inicioData.accionesRapidas" class="mb-4" />

            <upcoming-due-card :items="inicioData.proximosVencimientos" class="non-member-movements-card" />
          </v-col>

          <v-col cols="12" lg="4" class="non-member-interest-col">
            <interest-summary-card :intereses="inicioData.interesesAcumuladosColocacion" />
          </v-col>
        </v-row>
      </template>

      <v-row v-if="userBits.b_socio" class="dashboard-row">
        <v-col cols="12" lg="6" v-if="userBits.b_socio">
          <capital-composition-card :capital-composicion="inicioData.capitalComposicion" :capital-resumen="inicioData.capitalResumen"
          />
        </v-col>

        <v-col cols="12" md="6" lg="3" v-if="userBits.b_socio">
          <capital-summary-card :capital-resumen="inicioData.capitalResumen" />
        </v-col>

        <v-col cols="12" md="6" lg="3">
          <interest-summary-card :intereses="inicioData.interesesAcumuladosColocacion" />
        </v-col>
      </v-row>

      <v-row v-if="userBits.b_socio" class="dashboard-row">
        <v-col cols="12" lg="5">
          <quick-actions-card :acciones="inicioData.accionesRapidas" />
        </v-col>

        <v-col cols="12" lg="7">
          <upcoming-due-card :items="inicioData.proximosVencimientos" />
        </v-col>
      </v-row>

      <benefits-grid :beneficios="inicioData.beneficios" />
    </template>

    <mora-dialog v-if="dialogoMora" />
  </v-container>
</template>

<script>
import auth from "@/auth/auth";
import MoraDialog from "@/components/inicio/MoraDialog.vue";
import { mapActions, mapState } from "vuex";
import CargandoApp from "@/components/app/CargandoApp.vue";
import home from "@/services/home";
import QuickActionsCard from "@/components/inicio/dashboard/QuickActionsCard.vue";
import UpcomingDueCard from "@/components/inicio/dashboard/UpcomingDueCard.vue";
import InterestSummaryCard from "@/components/inicio/dashboard/InterestSummaryCard.vue";
import CapitalCompositionCard from "@/components/inicio/dashboard/CapitalCompositionCard.vue";
import CapitalSummaryCard from "@/components/inicio/dashboard/CapitalSummaryCard.vue";
import PatrimonyCard from "@/components/inicio/dashboard/PatrimonyCard.vue";
import PersonalInfoCard from "@/components/inicio/dashboard/PersonalInfoCard.vue";
import ProductCardsGrid from "@/components/inicio/dashboard/ProductCardsGrid.vue";
import BenefitsGrid from "@/components/inicio/dashboard/BenefitsGrid.vue";

export default {
  metaInfo: { title: "Inicio" },
  components: {
    "mora-dialog": MoraDialog,
    CargandoApp,
    QuickActionsCard,
    UpcomingDueCard,
    InterestSummaryCard,
    CapitalCompositionCard,
    CapitalSummaryCard,
    PatrimonyCard,
    PersonalInfoCard,
    ProductCardsGrid,
    BenefitsGrid
  },
  data: function () {
    return {
      user: null,
      metaInfo: { title: "Inicio" },
      loading: true,
      inicioData: {
        patrimonio: {
          total: 0,
          variacion: ""
        },
        productos: [],
        capitalResumen: {
          saldoTotal: 0,
          disponibleRetiro: 0,
          ufSaldo: "0 UF",
          ufDisponible: "0 UF",
          detalle: []
        },
        interesesAcumuladosColocacion: null,
        capitalComposicion: [],
        proximosVencimientos: [],
        accionesRapidas: [],
        beneficios: []
      }
    };
  },
  computed: {
    ...mapState(["dialogoMora"]),
    ...mapState(["userBits"]),
    userLogged() {
      return auth.getUserLogged();
    }
  },
  methods: {
    ...mapActions(["setPublicidades"]),
    async getUserInfo() {
      await auth
        .userInfo(this.userLogged.id_cliente)
        .then((res) => {
          this.user = res.data;

          let dataUser = {
            tipo: this.user.b_empresa || 0,
            creditos: this.user.monto_creditos || 0,
            capital: this.user.monto_capital || 0,
            dap: this.user.monto_dap || 0,
            libretas: this.user.monto_libreta || 0
          };
          this.setPublicidades({ user: dataUser, mostrar: false });
        })
        .catch((error) => console.error(error));
    }
  },
  async mounted() {
    if (process.env.NODE_ENV !== "production") this.loading = true;
    await this.getUserInfo();
    this.inicioData = (await home.getHome()).data;
    this.loading = false;
  }
};
</script>

<style scoped lang="css">
.inicio-dashboard {
  color: #1f2d35;
  background: transparent;
  margin-left: auto;
  margin-right: auto;
  max-width: 1480px;
  min-height: calc(100vh - 40px);
  padding-bottom: 28px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
  padding-top: 24px !important;
}

.dashboard-header-row {
  margin-bottom: 18px;
}

.dashboard-header-row > .col,
.dashboard-row > .col,
.dashboard-row > [class*="col-"] {
  padding-bottom: 8px;
  padding-top: 8px;
}

.dashboard-title {
  color: var(--v-primary-base);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 8px;
}

.dashboard-subtitle {
  color: #4d6870;
  font-size: 0.98rem;
}

.dashboard-inner-row > .col,
.dashboard-inner-row > [class*="col-"] {
  padding-bottom: 0;
  padding-top: 0;
}

.non-member-stack,
.non-member-interest-col {
  display: flex;
  flex-direction: column;
}

.non-member-movements-card {
  flex: 1 1 auto;
}

@media (min-width: 1904px) {
  .inicio-dashboard {
    max-width: 1480px;
  }
}

@media (max-width: 959px) {
  .inicio-dashboard {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}

@media (max-width: 599px) {
  .inicio-dashboard {
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-top: 14px !important;
  }

}
</style>
